module.exports = __webpack_public_path__ + "img/fd-zh-001.b0429d04.png";